import { render, staticRenderFns } from "./PermissionSelector.vue?vue&type=template&id=149c533e&scoped=true&"
import script from "./PermissionSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionSelector.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSelector.vue?vue&type=style&index=0&id=149c533e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149c533e",
  null
  
)

export default component.exports